import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/inbox")({
  component: DashboardInboxRoute,
});

function DashboardInboxRoute() {
  return <Outlet />;
}
